import { Box } from "@mui/material";
import React, { useEffect } from "react";
import Sidebar from "../../components/SidebarLayout/Sidebar";
import { useDispatch, useSelector } from "react-redux";
import VesselMasterContent from "../../components/Masters/VesselMaster/VesselMasterContent";
import { getVesselTypeMasterList } from "../../redux/actions/mastersAction";

const VesselMaster = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(
      getVesselTypeMasterList({
        active: "true",
        searchByFirstName: "",
        limit: "",
        offset: "",
      })
    );
  }, []);

  return (
    <>
      <Sidebar activeTab="Masters" title="Masters">
        <Box className="globalContainer_For_Content">
          <VesselMasterContent />
        </Box>
      </Sidebar>
    </>
  );
};

export default VesselMaster;
